function InputError({ message }) {
  return <span className="input__error">{message}</span>;
}

export default InputError;
